<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
      <template #footerShort>
        <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px]">
          <client-only>
            <div>
              <AtomButtonDropdown
                :items="directions"
                :custom-label="selectedDirection ? selectedDirection.text : 'Направление'"
                :initial-index="indexDirection"
                @select="onDirectionSelect"
              />
            </div>
          </client-only>
          <client-only>
            <div v-if="!isAcademyDirection">
              <AtomButtonDropdown
                :items="clubs"
                :custom-label="selectedClub ? selectedClub.text : 'Клуб'"
                :initial-index="indexClub"
                @select="onClubSelect"
              />
            </div>
          </client-only>
        </div>
      </template>
    </SectionHero>
    <SectionDefault>
      <Builder :blocks="blocks" :context="{ isAcademyDirection, vacancies: filteredVacancies }" />
    </SectionDefault>
  </main>
</template>

<script>
import AtomButtonDropdown from '../components/atoms/AtomButtonDropdown'
import Builder from '../components/builder/Builder'
import pageBuilder from '../components/mixins/pageBuilder.js'
import OrganismHero from '../components/organisms/layouts/OrganismHero'
import SectionDefault from '../components/templates/layouts/SectionDefault'
import SectionHero from '../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'career',
})

const STATIC_DIRECTION_ACADEMY = { text: 'Академия фитнеса', slug: 'academy' }

export default {
  name: 'Career',
  components: {
    Builder,
    SectionDefault,
    SectionHero,
    OrganismHero,
    AtomButtonDropdown,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      vacancies: [],
      hero: {
        variant: 'dark-parallax',
        title1: 'карьера',
        title2: 'в encore',
        image: 'career/hero.webp',
        imageMobile: 'career/hero-mobile.jpg',
        breadcrumbs: c.$breadcrumbs.career(),
      },
      // directions: [
      //   { text: 'Фитнес', slug: 'fitness' },
      //   { text: 'Менеджмент', slug: 'managment' }
      // ],
    }
  },
  async fetch() {
    const id = `vacancies`
    this.vacancies =
      this.$store.state.modules.content[id] || (await this.$store.dispatch('modules/content/getContent', { id })) || []
  },
  computed: {
    filteredVacancies() {
      if (!this.selectedDirection && !this.selectedClub) {
        return this.vacancies
      }
      return this.vacancies
        .filter(({ clubs }) => clubs && this.ensureArray && this.sortForClub(this.ensureArray(clubs)))
        .filter(({ type }) => {
          return !this.selectedDirection || type == this.selectedDirection.slug
        })
    },
    clubs() {
      const clubsItems = this.vacancies.reduce((acc, { clubs }, idx) => {
        clubs &&
          this.ensureArray &&
          this.ensureArray(clubs).forEach(
            clubItem => (acc[clubItem.slug] = { text: clubItem.title, slug: clubItem.slug }),
          )

        return acc
      }, {})
      return Object.values(clubsItems)
    },
    directions() {
      const filterAcc = {}
      const filterdItems = this.vacancies.filter(({ type }) =>
        type && !filterAcc[type] ? (filterAcc[type] = type) || true : false,
      )
      const directionItems = filterdItems.reduce((acc, { type }, index) => {
        if (index === filterdItems.length - 1) {
          acc[STATIC_DIRECTION_ACADEMY.slug] = STATIC_DIRECTION_ACADEMY
        }
        if (!type || type in acc) return acc
        acc[type] = { text: type, slug: type }
        return acc
      }, {})
      return Object.values(directionItems)
    },
    indexDirection() {
      return this.directions.findIndex(({ slug }) => slug == this.$route.query.direction)
    },
    indexClub() {
      return this.clubs.findIndex(({ slug }) => slug == this.$route.query.club)
    },
    isAcademyDirection() {
      return this.$route.query.direction === STATIC_DIRECTION_ACADEMY.slug
    },
    selectedDirection() {
      return this.directions[this.indexDirection]
    },
    selectedClub() {
      return this.clubs[this.indexClub]
    },
  },
  methods: {
    onDirectionSelect(i) {
      const direction = this.directions[i] || {}
      if (this.$route.query.direction === direction.slug) return

      this.$router.replace({
        query: {
          ...this.$route.query,
          direction: direction.slug,
        },
      })
    },
    onClubSelect(i) {
      const club = this.clubs[i] || {}
      if (this.$route.query.club === club.slug) return

      this.$router.replace({
        query: {
          ...this.$route.query,
          club: club.slug,
        },
      })
    },
    sortForClub(value) {
      if (this.selectedClub?.slug) {
        const isHasClub = value.some(({ slug }) => slug === this.selectedClub.slug)
        return !this.selectedClub || isHasClub
      } else {
        return value
      }
    },
  },
}
</script>
